import { openDB } from 'idb';
import { parseEncryptedWalletBlob, parseWatchedAddress, } from './schema.js';
const DB_NAME = 'gonka-wallet';
const DB_VERSION = 2;
const WALLET_STORE = 'wallets';
const SETTINGS_STORE = 'settings';
const WATCHED_STORE = 'watched_addresses';
export async function openWalletDb() {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db, oldVersion) {
            // v1: initial wallets + settings stores
            if (!db.objectStoreNames.contains(WALLET_STORE)) {
                db.createObjectStore(WALLET_STORE, { keyPath: 'id' });
            }
            if (!db.objectStoreNames.contains(SETTINGS_STORE)) {
                db.createObjectStore(SETTINGS_STORE);
            }
            // v2: watched_addresses store (Phase F)
            if (oldVersion < 2 && !db.objectStoreNames.contains(WATCHED_STORE)) {
                db.createObjectStore(WATCHED_STORE, { keyPath: 'id' });
            }
        },
    });
}
export async function saveWallet(db, blob) {
    const validated = parseEncryptedWalletBlob(blob);
    await db.put(WALLET_STORE, validated);
}
export async function loadWallets(db) {
    const rows = await db.getAll(WALLET_STORE);
    return rows.map((row) => parseEncryptedWalletBlob(row));
}
export async function deleteWallet(db, id) {
    await db.delete(WALLET_STORE, id);
}
export async function saveWatchedAddress(db, row) {
    const validated = parseWatchedAddress(row);
    // Defence-in-depth: reject duplicates at the persistence layer so
    // concurrent tabs racing an add can't both succeed.
    const existing = await db.getAll(WATCHED_STORE);
    if (existing.some((e) => e.address === validated.address && e.id !== validated.id)) {
        throw new Error(`Address ${validated.address} is already watched`);
    }
    await db.put(WATCHED_STORE, validated);
}
export async function loadWatchedAddresses(db) {
    const rows = await db.getAll(WATCHED_STORE);
    return rows.map((row) => parseWatchedAddress(row));
}
export async function deleteWatchedAddress(db, id) {
    await db.delete(WATCHED_STORE, id);
}
export async function wipeAll(db) {
    await db.clear(WALLET_STORE);
    await db.clear(WATCHED_STORE);
    // SETTINGS_STORE is deliberately NOT cleared. Per §9.4 of the MVP
    // spec, settings (language, autolock, etc) survive a wipe.
}
//# sourceMappingURL=db.js.map